import pagamentobeneficiosMenu from './beneficios/pagamentoBeneficios/menu';
import hospedagemMenu from './hospedagem/menu.js';
import hospedagemPrazosMenu from './hospedagem/menuPrazos.js';
import tramitacoesMenu from './tramitacoes-juridicas/menu.js';
import motMenu from './mao-de-obra-temporaria/menu.js';
import consultasDocflowMenu from '../consultas/processos/menu.js';
import licitacoesMenu from '../licitacoes/menu.js';

const menu = {
    label: 'SOLICITAÇÕES',
    icon: 'pi pi-fw pi-sitemap',
    rules: [
        ...pagamentobeneficiosMenu.rules,
        ...hospedagemMenu.rules,
        ...hospedagemPrazosMenu.rules,
        ...tramitacoesMenu.rules,
        ...motMenu.rules,
        ...consultasDocflowMenu.rules,
        ...licitacoesMenu.rules,
    ],
    items: [
        licitacoesMenu,
        {
            label: 'Benefícios',
            icon: 'pi pi-fw pi-folder',
            items: [
                {
                    label: 'Pagamentos',
                    icon: 'pi pi-fw pi-sitemap',
                    to: '/solicitacoes/pagamento-beneficios',
                    matchChildren: true,
                    rules: [''],
                },
                {
                    label: 'Bolsas',
                    icon: 'pi pi-fw pi-users',
                    to: '/solicitacoes/funcionarios-aptos',
                    rules: ['ANALISTA', 'GERENTE'],
                    requiredUnidade: 'UNIDADE DE GESTÃO DE PESSOAS',
                },
                {
                    label: 'Regras',
                    icon: 'pi pi-fw pi-sliders-h',
                    to: '/solicitacoes/regras',
                    rules: ['ANALISTA', 'GERENTE'],
                    requiredUnidade: 'UNIDADE DE GESTÃO DE PESSOAS',
                },
            ],
            rules: [''],
        },
        {
            label: 'Translado/Veículos',
            icon: 'pi pi-fw pi-car',
            to: '/solicitacoes/translado',
            matchChildren: true,
            rules: [''],
        },
        hospedagemMenu,
        hospedagemPrazosMenu,
        tramitacoesMenu,
        motMenu,
        consultasDocflowMenu,
    ],
};

export default menu;
